import { common } from '@tencent/ceiba-base-components';
import LoginBase from './base';
import LoginGame from './game';

const pluginPrefix = 'login';
const camelize = str => str.replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
function getPluginName(ast, name) {
  return `$${name}${camelize(`-${ast}`)}Plugin`;
}
const loginBaseHandler = new LoginBase();
const loginGameHandler = new LoginGame();
/**
 * 当游戏内，则返回通用msdk游戏插件，否则如果有业务插件方法，则返回业务插件，最后返回base插件
 * @param {*} Vue
 * @param {*} eventName
 * @returns
 */
function getHandler(Vue, eventName) {
  console.log('common.platform.isGame=', common.platform.isGame);
  if (common.platform.isGame && Vue.prototype.$actInfo.ast !== 'cjm') return loginGameHandler;
  const pluginName = getPluginName(Vue.prototype.$actInfo.ast, pluginPrefix);
  if (Vue.prototype[pluginName] && Vue.prototype[pluginName][eventName]) {
    return Vue.prototype[pluginName];
  }
  return loginBaseHandler;
}
const loginPlugin = {
  install(Vue) {
    Vue.prototype.$login = {
      /**
       * 初始化登录插件
       * @param {*} params
       * @returns
       */
      initLogin: async (params) => {
        console.info('initLogin');
        return await getHandler(Vue, 'initLogin').initLogin(params);
      },
      /**
       * 执行登入操作
       * @param {*} params
       * @returns
       */
      login: async (params) => {
        console.info('login');
        return await getHandler(Vue, 'login').login(params);
      },
      /**
       * 检查登录态，最重要
       * @returns 是否登录以及登录信息
       */
      checkLogin: async (params) => {
        console.info('checkLogin');
        // 判断是否有红包标识。有红包标识并且在微信内，仅限QQ登录
        const isRedPacket = common.tool.getQueryParams('C_IS_RED_PACKET');
        const accType = common.tool.getCookie('acctype');
        if (isRedPacket && common.platform.isWX && accType === 'wx') {
          console.log('checkLogin isRedPacket = ', isRedPacket, ', isWX = ', common.platform.isWX, ', accType = ', accType);
          // 原有微信登录Cookie，退出重新登录
          await getHandler(Vue, 'logout').logout(params);
          return {
            isLogin: false,
            userInfo: {},
          };
        }
        const loginRes = await getHandler(Vue, 'checkLogin').checkLogin(params);
        console.log('checkLogin return isLogin=', loginRes.isLogin, ' userInfo=', loginRes.userInfo);
        return loginRes;
      },
      /**
       * 执行登出操作
       * @returns
       */
      logout: async (params) => {
        console.info('logout');
        return await getHandler(Vue, 'logout').logout(params);
      },
      /**
       * 检查当前绑定角色
       * @returns
       */
      checkRoleInfo: async (params) => {
        console.info('checkRoleInfo');
        const roleRes = await getHandler(Vue, 'checkRoleInfo').checkRoleInfo(params);
        console.log('checkLogin return isRoleReady=', roleRes.isRoleReady, ' userInfo=', roleRes.roleInfo);
        return roleRes;
      },
    };
  },
};

export default loginPlugin;
